import { motion } from "framer-motion";
import { Leaf, MapPin, Quote } from "lucide-react";
export default function Founder() {
  return (
    <section className="relative bg-background overflow-hidden" data-testid="founder-section">
      <div className="relative px-6 md:px-12 max-w-5xl mx-auto py-24 sm:py-32">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <span className="font-mono text-xs uppercase tracking-[0.2em] text-emerald-400">
            The Founder
          </span>
          <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-display font-bold tracking-tight max-w-3xl">
            Built by someone who lives it.
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="mt-10 border border-white/10 bg-card p-7 sm:p-10"
          data-testid="founder-card"
        >
          <div className="flex flex-col sm:flex-row sm:items-center gap-5">
            <div className="w-16 h-16 shrink-0 rounded-full bg-gradient-to-br from-ember/25 to-emerald-500/25 border border-white/10 flex items-center justify-center">
              <Leaf className="w-7 h-7 text-emerald-400" data-testid="founder-leaf" />
            </div>
            <div>
              <p className="font-display font-bold text-2xl" data-testid="founder-name">
                Barry McColman
              </p>
              <p className="font-mono text-xs uppercase tracking-[0.2em] text-ember mt-1">
                Founder, AfterBurn
              </p>
              <div className="mt-3 flex flex-wrap gap-2">
                <span className="inline-flex items-center gap-1.5 border border-emerald-500/40 bg-emerald-500/10 px-3 py-1 font-mono text-[11px] uppercase tracking-wide text-emerald-400">
                  <Leaf className="w-3.5 h-3.5" /> Nipissing First Nation
                </span>
                <span className="inline-flex items-center gap-1.5 border border-white/15 px-3 py-1 font-mono text-[11px] uppercase tracking-wide text-muted-foreground">
                  <MapPin className="w-3.5 h-3.5" /> NFN Reserve · Ontario, Canada
                </span>
              </div>
            </div>
          </div>

          <div className="mt-8 space-y-5 text-base sm:text-lg text-muted-foreground leading-relaxed">
            <p>
              <span className="text-foreground font-display font-semibold">Welcome.</span> I'm Barry
              McColman - Bear, founder of AfterBurn — and a member of Nipissing First Nation. I live on the
              NFN Reserve in Ontario, Canada, where I hunt and fish for sustenance. My way of life depends
              on healthy forests, so protecting them isn't just a cause to me — it's home, and it's survival.
            </p>
            <p>
              That's why AfterBurn funds the three things the boreal needs to recover:{" "}
              <span className="text-emerald-400">reforestation</span>, rebuilding the communities that
              lose everything, and supporting the <span className="text-ember">first responders</span> on
              the front lines. Keeping the boreal alive and growing back through these fires is essential —
              not just for me now, but for the generations that come after us.
            </p>
          </div>

          <div className="mt-8 border-l-2 border-emerald-500 pl-5 py-1" data-testid="founder-quote">
            <Quote className="w-5 h-5 text-emerald-400 mb-2" />
            <p className="font-display font-semibold text-lg sm:text-xl text-foreground leading-relaxed">
              "I hunt and fish to live. The forest isn't a backdrop — it's home, food, and the future
              I want to protect."
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
